import request from "../utils/request"
import { stringify } from 'qs';


// 登录
export function login(data) {
  return request("/admin/community/logon", {
    method: "POST",
    data,
  });
}

//退出登录
export function signOut() {
  return request("/cloud/api/account/signOut", {
    method: "POST",
  });
}

// 获取运营用户详情
export function userInfo() {
  return request("/admin/community/details", {
    method: "POST",
  });
}

// 重置密码
export function reset(data) {
  return request("/admin/community/set_wpd", {
    method: "POST",
    data,
  });
}

// 获取用户列表
export function fetchUser(data) {
  return request("/admin/community/user_list", {
    method: "POST",
    data,
  });
}

// 用户设置
export function editUser(data) {
  return request("/admin/community/user_set", {
    method: "POST",
    data,
  });
}

// 用户删除
export function deleteUser(data) {
  return request("/admin/community/user_del", {
    method: "POST",
    data,
  });
}

// 获取运营用户
export function fetchCommunityUser() {
  return request("/admin/community/list", {
    method: "POST",
  });
}

// 添加运营用户
export function addCommunityUser(data) {
  return request("/admin/community/add", {
    method: "POST",
    data,
  });
}

// 添加运营用户
export function editCommunityUser(data) {
  return request("/admin/community/set", {
    method: "POST",
    data,
  });
}

// 添加运营用户
export function deleteCommunityUser(data) {
  return request("/admin/community/del", {
    method: "POST",
    data,
  });
}

// 重置运营用户密码
export function resetCommunityUser(data) {
  return request("/admin/community/resetting", {
    method: "POST",
    data,
  });
}

// 获取用户是否购买过
export function isFirstBuy(data){
  return request("/cloud/api/product/trade/status", {
    method: "POST",
    data,
  });
}
//是否展示知识套餐购买提示
export function isShowProductTips(data){
  return request("/cloud/api/course/live/showProductTips", {
    method: "POST",
    data,
  });
}

// 支付宝获取用户是否购买过
export function isFirstBuy2(data){
  return request("/cloud/api/product/trade/status/v2", {
    method: "POST",
    data,
  });
}

// 绑定手机号发送验证码
export function sendBindCode(data){
  return request("/cloud/api/account/sms/bind/mobile", {
    method: "POST",
    data,
  });
}

// 绑定手机号
export function bindPhone(data){
  return request("/cloud/api/account/bind/mobile", {
    method: "POST",
    data,
  });
}

// 优惠券详情
export function getTicketInfo(id){
  return request(`/cloud/api/user/coupon/${id}/info`, {
    method: 'POST'
  })
}
// 领取优惠券
export function getTicket(data){
  let params = {r: data.r}
  return request(`/cloud/api/user/coupon/${data.id}/receive`, {
    method: 'POST',
    data: params
  })
}

// 获取用户信息
export function getUserInfo(){
  return request(`/cloud/api/account/userInfo`, {
    method: 'GET',
  })
}

// 获取用户订单
export function getOrder(data){
  return request(`/cloud/api/user/order/list`, {
    method: 'GET',
    params:{...data,pageSize:20}
  })
}

// 获取用户学习记录
export function getStudy(page){
  return request(`/cloud/api/user/courseSet/view/list?pageIndex=${page}&pageSize=20`, {
    method: 'GET',
  })
}

//获取用户优惠券列表
export function getUserTicket(page){
  return request(`/cloud/api/user/coupon/list?pageIndex=${page}&pageSize=20`, {
    method: 'GET',
  })
}

//拉取订单二维码
export function orderNoQr(orderNo){
  return request(`/cloud/api/order/${orderNo}/qrcode`, {
    method: 'GET',
  })
}

// 获取问卷列表
export function getExerciseList(page){
  return request(`/cloud/api/user/exercise/record/list?pageIndex=${page}&pageSize=20`, {
    method: 'GET',
  })
}

export function signIn(data) {
  return request("/cloud/api/account/signIn", {
    method: "POST",
    data
  });
}
// 添加收获地址
export function addAddress(data){
  return request(`/cloud/api/user/addr/add`, {
    method: 'POST',
    data
  })
}

// 收获地址列表
export function getAddress(){
  return request(`/cloud/api/user/addr/list`, {
    method: 'GET',
  })
}

// 更新收获地址
export function updateAddress(data){
  return request(`/cloud/api/user/addr/update`, {
    method: 'POST',
    data
  })
}

// 删除收获地址
export function delAddress(id){
  return request(`/cloud/api/user/addr/${id}/del`,{
    method: 'DELETE',
  })
}

// 检验是否存在收货地址
export function userExists(data){
  return request(`/cloud/api/user/addr/exists?${stringify(data)}`, {
    method: 'GET',
  })
}

// 保存订单收获地址
export function saveOrderAddress(data){
  return request(`/cloud/api/user/addr/insert/order`,{
    method: 'POST',
    data
  })
}

export function getCoin(){
  return request(`/cloud/api/account/coins`, {
    method: 'GET'
  })
}

export function getCoinList(data){
  return request(`/cloud/api/account/coin/list?${stringify(data)}`, {
    method: 'GET',
    data
  })
}

export function getCoinByPhone(data){
  return request(`/cloud/api/product/coins?${stringify(data)}`, {
    method: 'GET',
  })
}

export function getSchoolmate(data){
  return request(`/cloud/api/account/schoolmate/list?${stringify(data)}`, {
    method: 'GET',
    data
  })
}

export function getRiskResult(){
  return request(`/cloud/api/account/verifyAndRisk/result`,{
    method: 'GET',
  })
}

export function smsSend(data){
  return request(`/cloud/api/account/app/phone/login/sms`,{
    method: 'POST',
    data

  })
}

export function phoneLogin(data){
  return request(`/cloud/api/account/app/phone/login`,{
    method: 'POST',
    data

  })
}

export function resignInfo(data){
  return request(`cloud/api/order/query/resignInfo`,{
    method: 'POST',
    data

  })
}

export function checkIn(){
  return request('/cloud/api/user/singIn',{
    method:'GET'
  })
}

